import React from 'react'
import {Link} from 'react-router-dom';
import {FaHeart, FaCartPlus} from 'react-icons/fa';
import { useSelector } from 'react-redux';
const Nav = () => {

    const {totalQuantity} = useSelector(state => state.chosenProducts)
    const {favTotalQuantity} = useSelector(state => state.favouriteProducts)
    return (
        <nav>
            <div className="container">
                <div className="nav-content">
                    <Link to="/" className="logo">Store</Link>
                    <ul className="nav-icons">
                        <Link to="/favourite"> <li><FaHeart className="nav-icon" /> <span className="badge">{favTotalQuantity}</span></li></Link>
                        <Link to="/cart"><li><FaCartPlus className="nav-icon"/> <span className="badge">{totalQuantity}</span></li></Link>
                    </ul>
                </div>
            </div>
        </nav>
    )
}

export default Nav
